import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import CarSolutions from "@/pages/CarSolutions";
import WhyAbayle from "@/pages/WhyAbayle";
import Clients from "@/pages/Clients";
import Contact from "@/pages/Contact";
import CookiesPolicy from "@/pages/CookiesPolicy";
import CookieBanner, { hydrateTrackingFromConsent } from "@/components/CookieBanner";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    hydrateTrackingFromConsent();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/car-solutions" element={<CarSolutions />} />
          <Route path="/why-abayle" element={<WhyAbayle />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/cookies-policy" element={<CookiesPolicy />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <CookieBanner />
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            className: "font-sans",
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
